const notificationsMenu = [
  {
    System: 'NTF',
    isActive: false,
    menu: [
      { is_header: true, title: 'NotificationsManagement', isActive: true }, // عنوان إدارة الإشعارات

       
      {
        path: '/NTF/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },

      {
        path: '/NTF/Notifications',
        icon: 'fas fa-bell', // أيقونة الإشعارات
        title: 'NotificationsManagement',
        permission: 'NtxViewNotificationsList',
        isActive: true
      }

      // { is_header: true, title: 'إدارة الإشعارات', isActive: true },
      // {
      //   path: 'dashboard',
      //   icon: 'fas fa-home',
      //   title: 'HomePage',
      // },

      // {
      //   path: '/NTF',
      //   icon: 'bi bi-bell',
      //   title: ' الإشعارات',
      //   children: [
      //     {
      //       path: 'NTF/Notifications',
      //       title: 'إدارة الإشعارات',
      //       isActive: true,
      //     },
      //   ],
      // },
    ]
  }
];

export default notificationsMenu;
